import styled from "styled-components";
import { LoginArea } from "./components/LoginArea";
import { LogoMain } from "./components/Logo/index";
import { size, theme } from "../../helpers/theme";
import { DesktopMenu } from "./components/DesktopMenu";
import { useLocation } from "react-router-dom";
import { url } from "../../utils/url";
import SideBarMenuComponent from "./components/SideBarMenu";
import { useAppSelector } from "../../hooks/redux-hooks";
import { ApplicationState } from "../../redux/reducers";
import SessionService from "../../services/session-service";
import { useEffect, useState } from "react";

interface HeaderProps {
  isNerrowPage: boolean;
}
const Header = ({ isNerrowPage }: HeaderProps) => {
  const user = SessionService.getUser();
  const isLoged = user && user.token_dostepu !== null ? true : false;

  const _visibleMenu: string[] = [
    url.homePage,
    url.aboutUs,
    url.faq,
    url.offer,
  ];
  const [visibleMainLogo, setVisibleMainLogo] = useState(false);

  const location = useLocation();
  let isMainMenuIsVisible: boolean = true;

  _visibleMenu.includes(location.pathname)
    ? (isMainMenuIsVisible = true)
    : (isMainMenuIsVisible = false);

  return (
    // Tu bedzie header z nawigacją dla strony głównej użytkownika niezalogowanego oraz bez nawigacji dla zalogowanego

    <Container>
      <HeaderContainer>
        <SideBarMenuComponent
          setVisibleMainLogo={setVisibleMainLogo}
          isLoged={isLoged}
          isMainMenuIsVisible={isMainMenuIsVisible}
          role={user?.typ_uzytkownika}
        />
        {!visibleMainLogo ? (
          <LogoMain isLoged={isLoged} isNerrowPage={isNerrowPage} />
        ) : (
          <></>
        )}
        {isMainMenuIsVisible && !isLoged ? <DesktopMenu /> : <></>}
        {!isLoged && isMainMenuIsVisible ? <LoginArea /> : <></>}
      </HeaderContainer>
    </Container>
  );
};

export default Header;

const Container = styled.div`
  z-index: 1000;
  // width: 80%;
  height: 80px;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  min-width: 260px;
  //position: fixed;
  background-color: ${theme.colors.gray04_background};
  color: ${theme.colors.gray01_secondaryText};
  font-weight: ${theme.fontWeight.normal};

  @media (max-width: ${size.laptop}) {
    margin-bottom: 20px;
    //width: 96%;
    width: 100%;
    position: sticky;
    //background-color:${theme.colors.gray04_background};
  }
`;
const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;

  @media (max-width: ${size.laptop}) {
    flex-direction: col;
    flex-wrap: wrap;
  }
`;
